module.exports = __webpack_public_path__ + "static/media/student-snapshort2-point.6e880550.png";